
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Drawer from 'vux/src/components/drawer/index.vue'

import { mapState, mapMutations, mapActions } from 'vuex'
import { register } from 'register-service-worker'
import { strategyTips, threatLevelInfo } from './strategy-tips.js'

function canShowInstallPrompt() {
const installData = JSON.parse(localStorage.getItem('pwaInstallPromptData'));
if (!installData)
return true;

const { lastShown, count } = installData;
const today = new Date().toDateString();

if (count >= 5) {

return false;
}

if (lastShown === today) {

return false;
}

return true;
}

function updateInstallPromptData() {
const today = new Date().toDateString();
const installData = JSON.parse(localStorage.getItem('pwaInstallPromptData')) || { lastShown: null, count: 0 };

if (installData.lastShown !== today) {
installData.lastShown = today;
installData.count += 1;
localStorage.setItem('pwaInstallPromptData', JSON.stringify(installData));
}
}


const TreeNode = {
name: 'TreeNode',
props: {
nodeKey: String,
nodeData: [Object, String],
nodeName: String,
level: Number,
expandedNodes: Object
},
computed: {
isLeaf() {
return typeof this.nodeData === 'string'
},
isEmpty() {
return typeof this.nodeData === 'object' && this.nodeData !== null && Object.keys(this.nodeData).length === 0
},
isBye() {
return typeof this.nodeData === 'string' && this.nodeData.trim() === ''
},
isExpanded() {
return !!this.expandedNodes[this.nodeKey]
},
childCount() {
if (this.isLeaf || this.isEmpty) return 0
return Object.keys(this.nodeData).length
},

moveCount() {
if (!this.isLeaf || this.isBye) return 0


const moves = this.nodeData.match(/[a-o]\d+/g)
return moves ? moves.length : 0
},

displayMoves() {
if (!this.isLeaf || this.isBye) return ''

const moves = this.nodeData.match(/[a-o]\d+/g)
if (!moves) return ''

const maxMoves = 20
if (moves.length <= maxMoves) {
return this.nodeData
}

const displayedMoves = moves.slice(0, maxMoves)
return displayedMoves.join('') + '...'
}
},
render(h) {
const paddingLeft = (this.level * 20 + 12) + 'px'

if (this.isLeaf) {
if (this.isBye) {

return h('div', { class: 'tree-node' }, [
h('div', {
class: 'tree-item tree-bye',
style: { paddingLeft }
}, [
h('div', { class: 'node-content' }, [
h('div', { class: 'item-name' }, this.nodeName),
h('div', { class: 'item-bye-hint' }, '轮空')
])
])
])
} else {

return h('div', { class: 'tree-node' }, [
h('div', {
class: 'tree-item tree-leaf',
style: { paddingLeft },
on: {
click: (e) => {
e.stopPropagation()
this.$emit('load-game', this.nodeData, this.nodeName)
}
}
}, [
h('div', { class: 'node-content' }, [
h('div', { class: 'item-name-with-steps' }, [
h('span', { class: 'item-name' }, this.nodeName),
h('span', { class: 'item-steps' }, `(${this.moveCount}步)`)
]),
h('div', { class: 'item-moves' }, this.displayMoves)
])
])
])
}
} else if (this.isEmpty) {

return h('div', { class: 'tree-node' }, [
h('div', {
class: 'tree-item tree-empty',
style: { paddingLeft }
}, [
h('div', { class: 'node-content' }, [
h('div', { class: 'item-name' }, this.nodeName),
h('div', { class: 'item-empty-hint' }, '暂无数据')
])
])
])
} else {

const children = []


children.push(
h('div', {
class: 'tree-item tree-branch',
style: { paddingLeft },
on: {
click: (e) => {
e.stopPropagation()
this.$emit('toggle', this.nodeKey)
}
}
}, [
h('div', { class: 'node-content' }, [
h('span', {
class: ['expand-icon', { expanded: this.isExpanded }]
}, '▶'),
h('div', { class: 'item-name' }, this.nodeName),
h('div', { class: 'item-count' }, `${this.childCount}`)
])
])
)


if (this.isExpanded) {
const childNodes = Object.entries(this.nodeData).map(([childKey, childData]) => {
return h('tree-node', {
key: childKey,
props: {
nodeKey: this.nodeKey + '.' + childKey,
nodeData: childData,
nodeName: childKey,
level: this.level + 1,
expandedNodes: this.expandedNodes
},
on: {
toggle: (nodeKey) => this.$emit('toggle', nodeKey),
'load-game': (posStr, name) => this.$emit('load-game', posStr, name)
}
})
})

children.push(
h('div', { class: 'tree-children' }, childNodes)
)
}

return h('div', { class: 'tree-node' }, children)
}
}
}

export default {
components: {
ViewBox,
XHeader,
Tabbar,
TabbarItem,
Drawer,
TreeNode,
},
data: function () {
return {
showHeader: true,
drawerOpen: false,
showOpenings: false,
showProblems: false,
showGames: false,

showOpeningGuide: false,
openingsData: null,
problemsData: null,
gamesData: null,

expandedNodes: {}, // 记录展开的节点
showImageModal: false,
currentImage: null,
currentImageTitle: '',
strategyCollapse: {},
}
},
computed: {
...mapState('settings', ['language', 'showAttackFour', 'showLivingThree', 'showThreatAnalysis', 'showVCF', 'showStrategyTips', 'analyzeMode']),
...mapState('ai', ['messages']),
...mapState('ai', {
threatAnalysis: (state) => state.outputs.threatAnalysis
}),
route() {
return this.$route
},
sortedOpeningsData() {
if (!this.openingsData || !this.openingsData.structure) return {}
return this.sortDataByContent(this.openingsData.structure)
},
sortedProblemsData() {
if (!this.problemsData || !this.problemsData.structure) return {}
return this.sortDataByContent(this.problemsData.structure)
},
sortedGamesData() {
if (!this.gamesData || !this.gamesData.structure) return {}
return this.sortDataByContent(this.gamesData.structure)
},
strategyTips() {
return strategyTips
},

filteredBlackThreats() {
if (!this.threatAnalysis || !this.threatAnalysis.black) return []
return Object.entries(this.threatAnalysis.black)
.filter(([key, value]) => key !== 'positions' && value > 0)
.map(([key, value]) => ({ key, value }))
},

filteredWhiteThreats() {
if (!this.threatAnalysis || !this.threatAnalysis.white) return []
return Object.entries(this.threatAnalysis.white)
.filter(([key, value]) => key !== 'positions' && value > 0)
.map(([key, value]) => ({ key, value }))
},
},
methods: {
...mapMutations('settings', ['setValue']),
...mapActions('settings', ['readCookies']),
...mapActions(['getBrowserCapabilities']),
...mapActions('position', ['setPosStr']),
showMessages: function () {
this.drawerOpen = !this.drawerOpen
if (this.drawerOpen) {

this.loadOpeningsData()
}
},
toggleAttackFour: function () {
this.setValue({ key: 'showAttackFour', value: !this.showAttackFour })
},
toggleLivingThree: function () {
console.log('toggleLivingThree clicked, current value:', this.showLivingThree)
this.setValue({ key: 'showLivingThree', value: !this.showLivingThree })
},
toggleThreatAnalysis: function () {
console.log('toggleThreatAnalysis clicked, current value:', this.showThreatAnalysis)
this.setValue({ key: 'showThreatAnalysis', value: !this.showThreatAnalysis })
},
toggleVCF: function () {
console.log('toggleVCF clicked, current value:', this.showVCF)
this.setValue({ key: 'showVCF', value: !this.showVCF })
},
showThreatInfo: function () {
let threatInfo = `${threatLevelInfo.title}<br><br>`

threatLevelInfo.levels.forEach(category => {
threatInfo += `【${category.category}】<br>`
category.items.forEach(item => {
threatInfo += `${item.level}级 - ${item.desc}<br>`
})
threatInfo += '<br>'
})

this.$vux.alert.show({
title: '威胁分析说明',
content: threatInfo,
buttonText: '确定'
})
},
async loadOpeningsData() {
if (!this.openingsData) {
try {
const response = await fetch('/downloads/databases/openings/index.json')
this.openingsData = await response.json()

await this.loadSubOpeningsData()
} catch (error) {
console.error('加载开局数据失败:', error)
}
}
},
async loadProblemsData() {
if (!this.problemsData) {
try {
const response = await fetch('/downloads/databases/problems/index.json')
this.problemsData = await response.json()

await this.loadSubProblemsData()
} catch (error) {
console.error('加载题库数据失败:', error)
}
}
},
async loadGamesData() {
if (!this.gamesData) {
try {
const response = await fetch('/downloads/databases/games/index.json')
this.gamesData = await response.json()

await this.loadSubGamesData()
} catch (error) {
console.error('加载棋谱数据失败:', error)
}
}
},

async loadSubOpeningsData() {
if (!this.openingsData || !this.openingsData.structure) return

for (const [categoryName, categoryData] of Object.entries(this.openingsData.structure)) {
if (categoryData.dataSource) {
try {

let dataPath = categoryData.dataSource
if (dataPath.startsWith('../')) {
dataPath = `/downloads/databases/${dataPath.substring(3)}`
} else {
dataPath = `/downloads/databases/openings/${dataPath}`
}

const response = await fetch(dataPath)
const subData = await response.json()


if (subData.structure) {

if (Object.keys(subData.structure).length === 0) {
this.openingsData.structure[categoryName] = {}
} else {
this.openingsData.structure[categoryName] = subData.structure
}
} else {

this.openingsData.structure[categoryName] = subData
}
} catch (error) {
console.error(`加载${categoryName}数据失败:`, error)

this.openingsData.structure[categoryName] = {}
}
}
}
},
async loadSubGamesData() {
if (!this.gamesData || !this.gamesData.structure) return

for (const [categoryName, categoryData] of Object.entries(this.gamesData.structure)) {
if (categoryData.dataSource) {
try {

let dataPath = categoryData.dataSource
if (dataPath.startsWith('../')) {
dataPath = `/downloads/databases/${dataPath.substring(3)}`
} else {
dataPath = `/downloads/databases/games/${dataPath}`
}

const response = await fetch(dataPath)
const subData = await response.json()


if (subData.structure) {

if (Object.keys(subData.structure).length === 0) {
this.gamesData.structure[categoryName] = {}
} else {
this.gamesData.structure[categoryName] = subData.structure
}
} else {

this.gamesData.structure[categoryName] = subData
}
} catch (error) {
console.error(`加载${categoryName}数据失败:`, error)

this.gamesData.structure[categoryName] = {}
}
}
}
},
async loadSubProblemsData() {
if (!this.problemsData || !this.problemsData.structure) return

for (const [categoryName, categoryData] of Object.entries(this.problemsData.structure)) {
if (categoryData.dataSource) {
try {
const response = await fetch(`/downloads/databases/problems/${categoryData.dataSource}`)
const subData = await response.json()


if (subData.structure) {

if (subData.structure[categoryName]) {
this.problemsData.structure[categoryName] = subData.structure[categoryName]
} else {

if (Object.keys(subData.structure).length === 0) {
this.problemsData.structure[categoryName] = {}
} else {
this.problemsData.structure[categoryName] = subData.structure
}
}
} else {

this.problemsData.structure[categoryName] = subData
}
} catch (error) {
console.error(`加载${categoryName}数据失败:`, error)

this.problemsData.structure[categoryName] = {}
}
}
}
},
loadGame(posStr, name = '') {
this.setPosStr(posStr)
this.showOpenings = false
this.showProblems = false
this.showGames = false
this.expandedNodes = {}
if (name) {
this.$vux.toast.show({
text: `已加载: ${name}`,
type: 'success'
})
}
},
loadOpening(name, posStr) {
this.loadGame(posStr, name)
},
loadProblem(name, posStr) {
this.loadGame(posStr, name)
},

toggleNode(nodeKey) {
console.log('切换节点:', nodeKey)
this.$set(this.expandedNodes, nodeKey, !this.expandedNodes[nodeKey])
console.log('展开状态:', this.expandedNodes)
},
isNodeExpanded(nodeKey) {
return !!this.expandedNodes[nodeKey]
},
isLeafNode(value) {
return typeof value === 'string'
},
getHighestThreat(side) {
if (!this.threatAnalysis || !this.threatAnalysis[side]) return null

const threatLevels = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L']
const threats = this.threatAnalysis[side]

for (let level of threatLevels) {
if (threats[level] && threats[level] > 0) {
return level
}
}
return null
},
showOpeningImage(imageType) {
const images = {
'24start': {
src: '/images/24start.jpg',
title: this.$t('header.24Openings')
},
'startswort': {
src: '/images/startswort.jpg',
title: this.$t('header.openingAdvantage')
}
}

if (images[imageType]) {
this.currentImage = images[imageType].src
this.currentImageTitle = images[imageType].title
this.showImageModal = true
this.showOpeningGuide = false
}
},
closeImageModal() {
this.showImageModal = false
this.currentImage = null
this.currentImageTitle = ''
},
loadOpeningCategory(categoryName) {

this.loadOpeningsData().then(() => {

this.showOpenings = true
this.drawerOpen = false
this.expandedNodes = {}
this.$set(this.expandedNodes, categoryName, true)
})
},
sortDataByContent(structure) {

const entries = Object.entries(structure)


entries.sort(([keyA, valueA], [keyB, valueB]) => {
const isEmptyA = this.isDataEmpty(valueA)
const isEmptyB = this.isDataEmpty(valueB)


if (isEmptyA && !isEmptyB) return 1
if (!isEmptyA && isEmptyB) return -1


return keyA.localeCompare(keyB, 'zh-CN')
})


const sortedObj = {}
entries.forEach(([key, value]) => {
sortedObj[key] = value
})

return sortedObj
},
isDataEmpty(data) {

if (typeof data === 'string') return false 
if (typeof data === 'object' && data !== null) {
return Object.keys(data).length === 0 
}
return true 
},
toggleStrategyTips() {
this.setValue({ key: 'showStrategyTips', value: !this.showStrategyTips })
},
toggleAnalyzeMode() {
console.log('toggleAnalyzeMode clicked, current value:', this.analyzeMode)


if (!this.analyzeMode) {
this.setValue({ key: 'analyzeMode', value: true })
this.$vux.toast.show({
text: '分析模式已开启',
type: 'text'
})
} else {

this.setValue({ key: 'analyzeMode', value: false })
this.$store.commit('ai/clearAllRealtime')
this.$vux.toast.show({
text: '分析模式已关闭',
type: 'text'
})
}
},
initStrategyCollapse() {
const collapse = {};
for (const key in this.strategyTips) {
collapse[key] = !this.strategyTips[key].defaultCollapsed;
}
this.strategyCollapse = collapse;
},
toggleStrategyCollapse(key) {
this.$set(this.strategyCollapse, key, !this.strategyCollapse[key]);
},
},
watch: {
language(newValue) {
this.$i18n.locale = newValue
},
showOpenings(newValue) {
if (newValue) {
this.showProblems = false
this.showGames = false
this.showOpeningGuide = false
this.expandedNodes = {}
this.loadOpeningsData()
}
},
showProblems(newValue) {
if (newValue) {
this.showOpenings = false
this.showGames = false
this.showOpeningGuide = false
this.expandedNodes = {}
this.loadProblemsData()
}
},
showGames(newValue) {
if (newValue) {
this.showOpenings = false
this.showProblems = false
this.showOpeningGuide = false
this.expandedNodes = {}
this.loadGamesData()
}
},
showOpeningGuide(newValue) {
if (newValue) {
this.showOpenings = false
this.showProblems = false
this.showGames = false
this.expandedNodes = {}
}
},
},
created() {
this.getBrowserCapabilities()
this.readCookies()
if (!this.language) {
this.setValue({ key: 'language', value: this.$i18n.locale })
} else {
this.$i18n.locale = this.language
}
this.initStrategyCollapse();
},
mounted() {
const _this = this


document.addEventListener('click', (e) => {

setTimeout(() => {
const dropdownMenus = document.querySelectorAll('.dropdown-menu')
const headerButtons = document.querySelectorAll('.header-btn')

let clickedOnButton = false
headerButtons.forEach(btn => {
if (btn.contains(e.target)) {
clickedOnButton = true
}
})

let clickedOnMenu = false
dropdownMenus.forEach(menu => {
if (menu.contains(e.target)) {
clickedOnMenu = true
}
})


let clickedOnMenuItem = e.target.closest('.menu-item')

if (!clickedOnButton && !clickedOnMenu && !clickedOnMenuItem) {
_this.showOpenings = false
_this.showProblems = false
_this.showGames = false
_this.showDaily = false
_this.showOpeningGuide = false
}
}, 50)
})


this.$vux.alert.show_i18n = function (options) {
options.buttonText = _this.$t('common.ok')
_this.$vux.alert.show(options)
}
this.$vux.confirm.show_i18n = function (options) {
options.confirmText = _this.$t('common.confirm')
options.cancelText = _this.$t('common.cancel')
_this.$vux.confirm.show(options)
}
this.$vux.confirm.prompt_i18n = function (value, options) {
options.confirmText = _this.$t('common.confirm')
options.cancelText = _this.$t('common.cancel')
_this.$vux.confirm.prompt(value, options)
}

window.onresize = function () {

_this.$store.commit('setScreenSize', {
width: document.documentElement.clientWidth,
height: document.documentElement.clientHeight,
})
}


if (process.env.NODE_ENV === 'production') {
register(`${process.env.BASE_URL}service-worker.js`, {
ready() {
console.log(
'App is being served from cache by a service worker.\n' +
'For more details, visit https://goo.gl/AFskqB'
)
},
updated() {
_this.$vux.confirm.show_i18n({
title: _this.$t('update.title'),
content: _this.$t('update.msg'),
onConfirm() {
location.reload()
},
onCancel() { }
})
},
error(error) {
console.error('Error during service worker registration:', error)
}
})

window.addEventListener('beforeinstallprompt', (e) => {
if (!canShowInstallPrompt()) {

return;
}


e.preventDefault();

const deferredPrompt = e;

_this.$vux.confirm.show_i18n({
title: _this.$t('install.title'),
content: _this.$t('install.msg'),
onConfirm() {

updateInstallPromptData();

deferredPrompt.prompt();
},
onCancel() {
updateInstallPromptData();
}
});
});
}
},
}
